import React from 'react';
import { FaBell } from 'react-icons/fa';
import { H4, Btn, Badges } from '../../../AbstractElements';
import { Announcement, Open, PackagingDepartment } from '../../../Constant';

import bgImage from '../../../assets/images/dashboard-2/announcement.jpg';
import Img from '../../../Utils/Ratio';
import RealTime from './RealTime';
import { Card, CardBody, Col } from 'reactstrap';

const Greeting = () => {
  return (
    <Col xl='4' md='5' lg='5'>
      <Card className='announcement-sec'>
        <Img className='img-fluid bg-img bg-img-cover' src={bgImage} alt='bg image' />
        <CardBody>
          <div>
            <H4>{Announcement}</H4>
            <span>{PackagingDepartment}</span>
            <RealTime />
            <div className='announcement-buttons'>
              <Btn color='white'>{Open}</Btn>
              <div className='iocn-bell ms-3'>
                <FaBell />

                <Badges color='light' className='badge rounded-pill'>
                  8
                </Badges>
              </div>
            </div>
          </div>
        </CardBody>
        <div className='shap-block'>
          <div className='shap1'>+</div>
          <div className='shap2 opicity-10'>+</div>
          <div className='shap3 opicity-50'>+ </div>
          <div className='shap4' />
          <div className='shap5 opicity-10'> </div>
          <div className='shap6' />
          <div className='shap7'> </div>
        </div>
      </Card>
    </Col>
  );
};

export default Greeting;
